import { preview } from '@/components/form/preview'
import { useOrderViolationTexts } from '@/intl'
import { useTexts } from './hooks/useTexts'
import { BulkViewData } from '../../hooks/useBulkViewData/types'
import { MixedTag } from '../../../components/MixedTag'

type Props = {
  bulkData: BulkViewData
}

export function RequiredTags(props: Props) {
  const {
    bulkData: { tagsIn, violations },
  } = props
  const { getViolationText } = useOrderViolationTexts()
  const texts = useTexts()
  const hasViolations = violations?.has('TGI')
  const tagsCount = tagsIn.value.length

  if (tagsCount === 0 && !tagsIn.hasAlsoMixedValues) {
    return (
      <preview.Field label={texts.requiredTags.label(tagsCount)}>
        <preview.NullValue />
      </preview.Field>
    )
  }

  if (tagsCount === 0 && tagsIn.hasAlsoMixedValues) {
    return (
      <preview.Field label={texts.requiredTags.label(tagsCount)}>
        <MixedTag>(mixed)</MixedTag>
      </preview.Field>
    )
  }

  return (
    <preview.Field label={texts.requiredTags.label(tagsCount)}>
      <preview.ViolationContainer
        violation={
          hasViolations ? <preview.ViolationBadge tooltip={getViolationText('TGI')} /> : null
        }
      >
        <preview.TagsList
          tags={tagsIn.value}
          maxHeightPx={48}
          extraTagContent={tagsIn.hasAlsoMixedValues ? <MixedTag /> : null}
        />
      </preview.ViolationContainer>
    </preview.Field>
  )
}
